import { showToast } from 'vant'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { decrypt, encrypt } from '@/utils/decryptQrc'
import useClickId from './useClickId'
import useTrack from '@/hooks/useTrack'
import useMediaReturn from '@/hooks/useMediaReturn'
import { getEnvironment } from '@/utils'

const useQrCode = () => {
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const userInfo = computed(() => store.state.userInfo)
  const commonDsl = computed(() => store.state.dslData.commonDsl)
  const peerInfo = computed(() => store.state.peerInfo)
  const { bid } = useClickId()
  const { track } = useTrack()
  const { addFriendFront } = useMediaReturn()
  const evenment = getEnvironment()

  const qrcodeUrl = ref('')
  const acquisitionLinkUrl = ref('')
  const qrcodeResData = ref({})
  const qrcodeState = ref('')
  const inputBidValue = ref('')

  const fetchQrcode = async (inputBid, isPeer, postbackEventType) => {
    const {
      code,
      data: resData,
      message,
    } = await store.dispatch(
      userInfo.value.unionid && !isPeer
        ? 'getCommonResourceQrcode'
        : 'getQrcodeWithoutBid',
      userInfo.value.unionid && !isPeer
        ? {
            groupId: encrypt(bid.value),
            unionId: userInfo.value.unionid,
          }
        : { bid: inputBid || bid.value }
    )
    if (code === 1) {
      qrcodeUrl.value = resData.imageUrl ? decrypt(resData.imageUrl) : ''
      acquisitionLinkUrl.value = resData.acquisitionLinkUrl ? decrypt(resData.acquisitionLinkUrl) : ''
      if (
        qrcodeUrl.value &&
        commonDsl.value?.channel?.indexOf('TENG_XUN_GDT_H5_YW') !== -1
      )
        await addFriendFront(postbackEventType)
    } else showToast(message || '二维码获取失败')
  }

  const fetchQrcode1 = async (qrcodeType, params, callback) => {
    let { bid: inputBid } = params
    let unionId = userInfo.value.unionid || route.query.unionid
    if (!unionId) return callback && callback(params)
    const {
      code,
      data: resData,
      message,
    } = await store.dispatch(
      qrcodeType === 1 && unionId
        ? 'getCommonResourceQrcode'
        : 'getMiniImageUrl',
        qrcodeType === 1 && unionId ?
        {
            groupId: encrypt(inputBid),
            unionId: unionId,
          }
        : { groupIdEncrypt: encrypt(inputBid), unionId: unionId }
    )
    console.log('resData:', resData)

    // 请求资源下发
    track('request_resource', {
      qr_state: resData?.state || '',
      shouquan_gzh: params?.publicKey || '',
      risk_type: peerInfo.value?.peerStatus,
      bid: inputBid || '',
      title_name: params?.title_name || params?.popName || '',
      evenment: evenment
    })



    if (code === 1) {
      qrcodeResData.value = resData || {}
      qrcodeUrl.value = resData.imageUrl ? decrypt(resData.imageUrl) : ''
      acquisitionLinkUrl.value = resData.acquisitionLinkUrl ? decrypt(resData.acquisitionLinkUrl) : ''
      qrcodeState.value = resData?.state || ''
      inputBidValue.value = inputBid || ''
      if (qrcodeUrl.value) {
        // 下发二维码
        track('send_qrcode', {
          qr_state: resData?.state || '',
          bid: inputBid || ''
        })
      }
      // if (acquisitionLinkUrl.value) {
      //   // 下发获客链接
      //   track('send_jfzg_hklj', {
      //     state: resData?.state || '',
      //     bid: inputBid || ''
      //   })
      // }
      if (!qrcodeUrl.value)  callback && callback(params)
    } else showToast(message || '二维码获取失败')
  }

  const notifyLongPressRecognize = (inputBid) => {
    notifyFinder(inputBid, qrcodeResData.value)
  }

  const notifyFinder = (inputBid, resData = {}) => {
    const notifyBid = inputBid || bid.value
    if (!notifyBid) return
    store.dispatch('corpAddRepeatNew', {
      bid: encrypt(notifyBid),
      unionId: userInfo.value.unionid,
      enterpriseAccountId: resData.enterpriseAccountId,
      enterpriseId: resData.enterpriseId,
      caseQrType: resData.caseQrType,
      logType: resData.logType,
      traceId: resData.traceId || '',
      userAction: 'userLongPressRecognizeQrCode',
    })
  }

  const fetchSamePeerStatus = async () => {
    // 如果选择了防同行并且unionid存在的话 那么就请求接口并向本地存储中保存同行状态
    if (userInfo.value.unionid) {
      await store.dispatch('getPeerStatus', {
        unionId: userInfo.value.unionid,
        groupId: bid.value,
      })
      // 如果是同行 就跳转到预设好的同行固定页
      if (peerInfo.value.isPeers) {
        router.push({
          path: `/peerPage/${new Date().getTime()}`,
          query: {
            pageCode: commonDsl.value?.peerPosition || 'tonghang_page'
          }
        })
        // window.location.href = commonDsl.value.samePeerPageUrl || ''
      }
    }
  }

  return {
    fetchQrcode,
    qrcodeUrl,
    acquisitionLinkUrl,
    fetchSamePeerStatus,
    fetchQrcode1,
    notifyLongPressRecognize,
    qrcodeResData,
    qrcodeState,
    inputBidValue,
  }
}

export default useQrCode
